import { action } from 'satcheljs';

/**
 * action to update replyToExternalSendersText
 * @param replyToExternalSendersText - the new value for replyToExternalSendersText
 * public action
 */
const setReplyToExternalSendersText = action(
    'setReplyToExternalSendersText',
    (replyToExternalSendersText: string) => ({
        replyToExternalSendersText,
    })
);

export default setReplyToExternalSendersText;
